import type { ActionContext } from 'vuex'

import type { ActionClass, ContextState } from '../../../models'

import { deepEqual } from '@empathyco/x-utils'

import { CONTEXT_CONSTS } from '../../../store/context/context.consts'

export class SetContextAction implements ActionClass {
  static execute(
    this: void,
    { state, commit }: ActionContext<ContextState, any>,
    context: ContextState,
  ): Promise<boolean> {
    const contextHasChanged = !deepEqual(context, state)
    if (contextHasChanged) {
      commit(CONTEXT_CONSTS.mutations.setContext, context)
    }
    return Promise.resolve(contextHasChanged)
  }
}
